import React, { ComponentProps, PropsWithChildren, ReactNode } from "react";
import { Modal } from "../../modal";
import { DialogButton } from "..";
import { SimpleDialog } from "../simple-dialog";

export const AlertDialog = ({
	children,
	title,
	message,
	messageHtml,
	ok,
	onOk,
	...modalProps
}: PropsWithChildren<{
	title?: ReactNode;
	message?: ReactNode;
	messageHtml?: string;
	ok: ReactNode;
	onOk?: () => void;
}> &
	ComponentProps<typeof Modal>) => {
	const Footer = () => (
		<>
			<DialogButton
				// eslint-disable-next-line jsx-a11y/no-autofocus
				autoFocus
				type="button"
				onClick={onOk}
			>
				{ok}
			</DialogButton>
		</>
	);
	return (
		<SimpleDialog
			className="alert-dialog"
			title={title}
			footer={<Footer />}
			contentHtml={messageHtml}
			onScrimClick={onOk}
			{...modalProps}
		>
			{message}
			{children}
		</SimpleDialog>
	);
};
